import React from 'react'
import classnames from 'classnames/bind'

import { Title, Text, Label } from 'components/typo'
import Person from 'components/shared/Person'
import Image from 'components/shared/Image'

import css from './styles.module.scss'

const cx = classnames.bind(css)

const CustomerCardContent = ({
  forwardRef,
  logo,
  label,
  title,
  text,
  theme,
  layout,
  author,
  isNameBlue,
  isSimpleCard
}) => {
  const image = typeof logo === "string" ? { media: { data: { attributes: { url: logo } } } } : logo
  return (
    <div ref={forwardRef} className={cx(layout, {
      [css.isSimpleCard]: isSimpleCard,
      [css.CustomerCardContent]: !isSimpleCard
    })}>
      {logo && (
        <Image
          fluid
          fit="contain"
          position="left"
          className={css.picture}
          {...image}
        />
      )}
      <div className={css.text}>
        {label && <Label theme={theme}>{label}</Label>}

        {title && (
          <Title className={css.title} size="small">
            {title}
          </Title>
        )}
        {text && (
          <Text className={cx({
            [css.description]: !isSimpleCard,
            [css.isSimpleCardDescription]: isSimpleCard
          })} size="small" theme="gray">
            {text}
          </Text>
        )}
        {author && (
          <Person
            className={cx(css.author, {
              [css.authorSimpleCard]: isSimpleCard
            })}
            image={author.image}
            companyLogo={author.companyLogo}
            name={author.name}
            description={author.description}
            isNameBlue={isNameBlue}
            isSimpleCard={isSimpleCard}
          />
        )}
      </div>
    </div>
  )
}

export default CustomerCardContent
